import React, { useEffect, useState } from "react";
import { StickyTable, Row, Cell } from "react-sticky-table";
import { HOST_URL } from "../../../helpers/constants/Constants";
import { ScheduleCategories } from "../ScheduleCategories";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import store from "../../../helpers/store/Store";
import {
  updateDynaPropValues,
  updateSelectedSchedule,
  updateSelectedPropValues,
  updateTagsCatsList,
  showTagsCatsList,
  showMetaPropTagList,
  updateAdditionalTabs,
} from "../../../helpers/actions/Action";
import { SpinnerCircularFixed } from "spinners-react";
import Select from "react-select";
import MetaPropertiesPropValueList from "../MetaPropertiesPropValueList";
import MetaPropertiesTagList from "../MetaPropertiesTagList";

const PressureTestSchedule = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dataIsSaved, setDataIsSaved] = useState(true);
  const [appliedFilter, setAppliedFilter] = useState("All Classes");
  const [dynaPropList, setDynaPropList] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);

  const dispatch = useDispatch();

  const dynaPropValues = useSelector(
    (state) => state.metaPropReducer.dynaPropValues
  );
  const statPropValues = useSelector(
    (state) => state.metaPropReducer.statPropValues
  );
  const elemWithProperties = useSelector(
    (state) => state.metaPropReducer.elementWithProperties
  );
  const categories = useSelector((state) => state.metaPropReducer.categories);
  const selectedModel = useSelector(
    (state) => state.getSelectedModelReducer.data
  );
  const selectedProject = useSelector(
    (state) => state.getSelectedProjectReducer.data
  );
  const selectedPropValues = useSelector(
    (state) => state.metaPropReducer.selectedPropValues
  );
  // const elemTagsCatsList = useSelector(
  //   (state) => state.metaPropReducer.elemTagsCatsList
  // );

  //HANDLE INPUT CHANGE
  const handleInputChange = (e) => {
    setDataIsSaved(false);
    var tagName = e.target.id.split("--")[0];
    var propName = e.target.id.split("--")[1];

    var dynaPropValuestemp = dynaPropValues;
    for (var i = 0; i < dynaPropValuestemp.length; i++) {
      if (dynaPropValuestemp[i].tag == tagName) {
        for (var j = 0; j < dynaPropValuestemp[i].propValueList.length; j++) {
          if (dynaPropValuestemp[i].propValueList[j].propName == propName) {
            dynaPropValuestemp[i].propValueList[j].propValue = e.target.value;
            break;
          }
        }
        break;
      }
    }

    // quickSave();
    dispatch(updateDynaPropValues([...dynaPropValuestemp]));
  };

  //CLICK HANDLER FOR SAVE BUTTON
  const handleSaveButtonClick = () => {
    setIsSaving(true);
    var formDataDynamic = new FormData();
    formDataDynamic.append("Data", JSON.stringify(dynaPropValues));
    var savedStatic = false,
      savedDynamic = false;

    axios({
      method: "post",
      url: HOST_URL + `/api/savedynamic`,
      data: formDataDynamic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        savedDynamic = true;
        if (savedStatic && savedDynamic) {
          setIsSaving(false);
          setDataIsSaved(true);
          alert("Data Saved");
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSaving(false);
      });

    var formDataStatic = new FormData();
    formDataStatic.append("Data", JSON.stringify(statPropValues));

    axios({
      method: "post",
      url: HOST_URL + `/api/savestatic`,
      data: formDataStatic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        savedStatic = true;
        if (savedStatic && savedDynamic) {
          setIsSaving(false);
          setDataIsSaved(true);
          alert("Data Saved");
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSaving(false);
      });

    var data = {
      ElemWithProps: JSON.stringify(elemWithProperties),
      Categories: JSON.stringify(categories),
      DynaPropValues: JSON.stringify(dynaPropValues),
      StatPropValues: JSON.stringify(statPropValues),
    };

    const tabSize =
      data.ElemWithProps.length +
      data.Categories.length +
      data.DynaPropValues.length +
      data.StatPropValues.length;

    // console.log("tabSize", tabSize);
    if (tabSize > 4700000) {
      store.dispatch(updateAdditionalTabs(false));
    } else {
      //redux state to change tab possible to true
      store.dispatch(updateAdditionalTabs(true));
      window.sessionStorage.setItem(
        selectedModel.fileName,
        JSON.stringify(data)
      );
    }
  };

  const quickSave = () => {
    var formDataDynamic = new FormData();
    formDataDynamic.append("Data", JSON.stringify(dynaPropValues));

    axios({
      method: "post",
      url: HOST_URL + `/api/savedynamic`,
      data: formDataDynamic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        setDataIsSaved(true);
      })
      .catch((error) => {
        console.log(error);
      });

    var formDataStatic = new FormData();
    formDataStatic.append("Data", JSON.stringify(statPropValues));

    axios({
      method: "post",
      url: HOST_URL + `/api/savestatic`,
      data: formDataStatic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        setDataIsSaved(true);
      })
      .catch((error) => {
        console.log(error);
      });

    var data = {
      ElemWithProps: JSON.stringify(elemWithProperties),
      Categories: JSON.stringify(categories),
      DynaPropValues: JSON.stringify(dynaPropValues),
      StatPropValues: JSON.stringify(statPropValues),
    };

    const tabSize =
      data.ElemWithProps.length +
      data.Categories.length +
      data.DynaPropValues.length +
      data.StatPropValues.length;

    // console.log("tabSize", tabSize);
    if (tabSize > 4700000) {
      store.dispatch(updateAdditionalTabs(false));
    } else {
      //redux state to change tab possible to true
      store.dispatch(updateAdditionalTabs(true));
      window.sessionStorage.setItem(
        selectedModel.fileName,
        JSON.stringify(data)
      );
    }
  };

  //CLICK HANDLER FOR REPORT GENERATION
  const handleGenrateReportButtonClick = (ele) => {
    if (selectedProject.text === "") {
      alert("Project name not found");
      return;
    }
    if (dataIsSaved === false) {
      alert("Please save your data first");
      return;
    }
    setIsSubmitting(true);
    var scheduleType = "pressure_test_schedule";

    var formData = new FormData();
    formData.append("ProjectName", selectedProject.text);
    formData.append("ScheduleType", scheduleType);
    formData.append("ScheduleCategories", JSON.stringify(ScheduleCategories));
    formData.append("FileName", selectedModel.fileName);
    // var fileName = selectedProject.text + "_" + scheduleType + ".xlsx";
    axios.defaults.withCredentials = true;
    axios({
      method: "post",
      url: HOST_URL + `/api/getreport`,
      data: formData,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        setIsSubmitting(false);
        alert("Schedule saved to BIM 360");
      })
      .catch((error) => {
        console.log(error);
        setIsSubmitting(false);
      });
  };

  const resetSchedule = () => {
    quickSave();
    store.dispatch(updateSelectedSchedule(""));
    store.dispatch(updateSelectedPropValues([]));
    store.dispatch(showTagsCatsList(false));
    store.dispatch(showMetaPropTagList(false));
  };

  const tableHeaders = [
    "Line Number",
    "Long Description (size)",
    "Type of Pressure Test",
    "Written Scheme of Examination Required",
    "Planned Test Pressure (barg)",
    "Test Duration (minutes)",
    "Date of Pressure Test",
    "Actual Test Pressure (barg)",
    "Carried Out by",
  ];

  const handleEditClassSelectChange = (selectedObject) => {
    setAppliedFilter(selectedObject.value);
    dispatch(updateSelectedPropValues([]));
    store.dispatch(showTagsCatsList(true));
  };

  useEffect(() => {
    if (appliedFilter) {
      createTagsCatsList();
    }
  }, [appliedFilter]);

  const createTagsCatsList = () => {
    if (elemWithProperties.length === 0) {
      return;
    }

    var tempElemTagsCatsList = [];
    var tempDynaPropList = [];

    elemWithProperties.forEach((elem, index) => {
      if (elem.category == appliedFilter) {
        tempElemTagsCatsList.push({
          tag: elem.tag,
          category: elem.category,
          isSelected: false,
        });

        if (tempDynaPropList.length === 0) {
          tempDynaPropList = elem.dynaProps;
        }
      }
    });

    setDynaPropList(tempDynaPropList);
    dispatch(updateTagsCatsList(tempElemTagsCatsList));
  };

  const handleEditPropertySelectChange = (selectedObjects) => {
    store.dispatch(showMetaPropTagList(true));
    var tempSelectedPropValues = [];
    if (selectedObjects == null) {
      return;
    }
    selectedObjects.forEach((selectedObject) => {
      var isExists = false;
      selectedPropValues.forEach((selectedPropValue) => {
        if (!isExists && selectedObject.value == selectedPropValue.propName) {
          isExists = true;
          tempSelectedPropValues.push(selectedPropValue);
        }
      });

      if (!isExists) {
        tempSelectedPropValues.push({
          propName: selectedObject.value,
          propValue: "",
        });
      }
    });
    dispatch(updateSelectedPropValues(tempSelectedPropValues));
  };

  useEffect(() => {
    const tempFilteredCategories = [...filteredCategories];
    categories.map((category) => {
      const valveScheduleCategories = ScheduleCategories.filter((item) => {
        return item.type === "pipeline_schedule";
      });
      if (valveScheduleCategories[0].categories.includes(category)) {
        tempFilteredCategories.push({ value: category, label: category });
      }
    });
    setFilteredCategories(tempFilteredCategories);
  }, [categories]);

  return (
    <>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-11">
              <h2 id="pageModalLabel" style={{ fontWeight: "bold" }}>
                Pressure Test Schedule for {props.project.text}
              </h2>
            </div>
            <div className="col-1">
              <button
                type="button"
                className="close"
                onClick={resetSchedule}
                data-dismiss="modal"
                data-keyboard="true"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <div className="row">
                <div
                  className="col-10"
                  style={{ height: "90vh", overflow: "auto" }}
                >
                  <div
                    className="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingBottom: "20px",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-lg btn-primary"
                      style={{ marginRight: 4 }}
                      onClick={handleSaveButtonClick}
                    >
                      <SpinnerCircularFixed
                        size={20}
                        thickness={180}
                        speed={140}
                        enabled={isSaving}
                        color="rgba(0, 114, 188, 1)"
                        secondaryColor="rgba(0, 0, 0, 0.92)"
                      />
                      {isSaving ? (
                        <span>Saving...</span>
                      ) : (
                        <span>Save Data</span>
                      )}
                    </button>
                    <button
                      type="button"
                      className="btn btn-lg btn-primary"
                      onClick={handleGenrateReportButtonClick}
                    >
                      <SpinnerCircularFixed
                        size={20}
                        thickness={180}
                        speed={140}
                        enabled={isSubmitting}
                        color="rgba(0, 114, 188, 1)"
                        secondaryColor="rgba(0, 0, 0, 0.92)"
                      />
                      {isSubmitting ? (
                        <span>Submitting...</span>
                      ) : (
                        <span>Submit to BIM360</span>
                      )}
                    </button>
                  </div>
                  <StickyTable
                    leftStickyColumnCount="2"
                    style={{ height: "90%" }}
                  >
                    <Row style={{ border: "3px solid rgb(0, 0, 0)" }}>
                      {tableHeaders.map((cell, index) => {
                        return (
                          <Cell
                            key={index}
                            style={{ textAlign: "center", fontSize: "0.9rem" }}
                          >
                            {cell}
                          </Cell>
                        );
                      })}
                    </Row>
                    {dynaPropValues.map((dynaItem, index) => {
                      return ScheduleCategories.filter((item) => {
                        return item.type === "pipeline_schedule";
                      })[0].categories.includes(dynaItem.category) ? (
                        <Row
                          key={dynaItem.tag + index}
                          style={{ border: "3px solid rgb(0, 0, 0)" }}
                        >
                          {tableHeaders.map((colName, index) => {
                            if (colName === "P&ID Drawing Number") {
                              return (
                                <Cell
                                  key={colName + index}
                                  style={{
                                    textAlign: "center",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {dynaItem.fileName.split(".")[0]}
                                </Cell>
                              );
                            } else {
                              var filteredDynaPropValue =
                                dynaItem.propValueList.filter(
                                  (propValueObj) => {
                                    return propValueObj.propName === colName;
                                  }
                                );

                              if (filteredDynaPropValue.length === 0) {
                                var statItems = statPropValues.filter(
                                  (statItem) => {
                                    return dynaItem.tag === statItem.tag;
                                  }
                                );

                                var filteredStatPropValue =
                                  statItems[0].propValueList.filter(
                                    (propValueObj) => {
                                      return propValueObj.propName === colName;
                                    }
                                  );

                                return filteredStatPropValue.length !== 0 ? (
                                  <Cell
                                    key={colName + index}
                                    style={{
                                      textAlign: "center",
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    {filteredStatPropValue[0].propValue}
                                  </Cell>
                                ) : (
                                  <Cell
                                    key={colName + index}
                                    style={{
                                      textAlign: "center",
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    {""}
                                  </Cell>
                                );
                              } else {
                                if (colName === "Type of Pressure Test") {
                                  return (
                                    <Cell
                                      key={colName + index}
                                      style={{
                                        textAlign: "center",
                                        fontSize: "0.8rem",
                                      }}
                                    >
                                      <select
                                        id={dynaItem.tag + "--" + colName}
                                        // type="text"
                                        value={
                                          filteredDynaPropValue[0].propValue
                                        }
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          Please select an option
                                        </option>
                                        <option value="Hydrostatic">
                                          Hydrostatic
                                        </option>
                                        <option value="Pneumatic">
                                          Pneumatic
                                        </option>
                                      </select>
                                    </Cell>
                                  );
                                } else {
                                  return (
                                    <Cell
                                      key={colName + index}
                                      style={{
                                        textAlign: "center",
                                        fontSize: "0.8rem",
                                      }}
                                    >
                                      <input
                                        id={dynaItem.tag + "--" + colName}
                                        type="text"
                                        value={
                                          filteredDynaPropValue[0].propValue
                                        }
                                        onChange={handleInputChange}
                                      />
                                    </Cell>
                                  );
                                }
                              }
                            }
                          })}
                        </Row>
                      ) : null;
                    })}
                  </StickyTable>
                </div>
                <div
                  className="col-2"
                  style={{ height: "90vh", overflow: "auto" }}
                >
                  {/* <EditMultiple /> */}
                  <div>
                    <p>
                      Select an object type from the drop down below this will
                      allow you to change multiple values at the same time.
                    </p>
                    <Select
                      //classNamePrefix={'typeahead-select'}
                      // value={"selectedOption"}
                      onChange={handleEditClassSelectChange}
                      options={filteredCategories}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      placeholder="Select Object Type"
                    />

                    <MetaPropertiesTagList />
                    <br />
                    <Select
                      //classNamePrefix={'typeahead-select'}
                      //value={"selectedOption"}
                      onChange={handleEditPropertySelectChange}
                      isMulti
                      options={dynaPropList.map((propName) => {
                        return { value: propName, label: propName };
                      })}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      placeholder="Select Properties"
                    />

                    <MetaPropertiesPropValueList />
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PressureTestSchedule;
